import React, { useState, useEffect, useRef } from "react";
import { saveAs } from "file-saver";
import "../../styles/ActionTrack.css";
import { useFetchActionReport } from "../../utils/hooks/ActionTrackHook";
import axios from "axios";
import {
  useFetchQueTypes,
  useFetchAudCycles,
} from "../../utils/hooks/UseFetchUrl";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import { Dropdown, Menu, message, Table, Tooltip } from "antd";
import { VerticalAlignBottomOutlined } from "@ant-design/icons";
import { base_url } from "../../utils/apiConfig";
import newStyled from "@emotion/styled";

const ActionTrack = () => {
  const [tabData, setTabData] = useState([]);
  const { data: queTypesData } = useFetchQueTypes(
    "/questionnaire_types_for_dashboard"
  );
  const { data: cyclesData } = useFetchAudCycles("/audit_cycle_for_dashboard");
  const {
    data: actionRepData,
    isLoading,
    getApiData: getactionRepApiData,
  } = useFetchActionReport();

  useEffect(() => {
    if (actionRepData) {
      setTabData(actionRepData);
    }
  }, [actionRepData]);
  const queId = queTypesData?.[0]?.id;
  const [cycleId, setCycleId] = useState(null);
  const [selectedQueId, setSelectedQueId] = useState(null);
  const [detailsData, setDetailsData] = useState([]);

  useEffect(() => {
    if (selectedQueId && cycleId) {
      getactionRepApiData(`audit_cycle/${cycleId}/action_reports`);
    }
  }, [cycleId, selectedQueId]);

  useEffect(() => {
    if (cyclesData && selectedQueId) {
      const filteredCycles = cyclesData.filter(
        (cycle) => cycle.questionnaire_type.id === selectedQueId
      );
      setDetailsData(filteredCycles);
      if (filteredCycles.length > 0) {
        setCycleId(filteredCycles[0].id);
      } else {
        setCycleId(null);
      }
    }
  }, [cyclesData, selectedQueId]);

  useEffect(() => {
    if (queId) {
      setSelectedQueId(queId);
    }
  }, [queId]);

  const [openDropdown, setOpenDropdown] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const handleSelectChange = (event) => {
    const selectedId = parseInt(event.target.value, 10);
    setSelectedQueId(selectedId);
    setSelectedOption(event.target.value);
  };

  const [selectedOption1, setSelectedOption1] = useState("");
  const handleSelectChange1 = (event) => {
    const selectedId1 = parseInt(event.target.value, 10);
    setSelectedOption1(event.target.value, 10);
    setCycleId(selectedId1);
    getactionRepApiData(`audit_cycle/${selectedId1}/action_reports`);
  };

  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleMarkAsCompleted = async (id) => {
    try {
      const token = localStorage.getItem("authToken");
      const url = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/action_report/${id}/change_status`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });
      if (response.status === 200) {
        const updatedData = tabData.map((item) =>
          item.id === id ? { ...item, status: "TAKEN" } : item
        );
        setTabData(updatedData);
      }
      getactionRepApiData(`audit_cycle/${cycleId}/action_reports`);
    } catch (error) {
      console.log("Error updating status:", error);
    }
  };

  const [statusFilter, setStatusFilter] = useState("ALL");
  const [newFilterData, setNewFilterData] = useState([]);
  useEffect(() => {
    const filtered = tabData.filter((item) =>
      statusFilter === "ALL" ? true : item.status === statusFilter
    );

    setNewFilterData(filtered);
  }, [tabData, statusFilter]);

  const columns = [
    {
      title: "Report ID",
      dataIndex: "audit_store_id",
      key: "audit_store_id",
      width: 20,
      className: "center-column",
      align: "center",
    },
    {
      title: "Person Responsible",
      dataIndex: "person_responsible",
      key: "person_responsible",
      width: 200,
      className: "center-column",
    },
    {
      title: "Target Date",
      dataIndex: "target_date",
      key: "target_date",
      width: 120,
      align: "center",
      className: "center-column",
      render: (target_date) =>
        target_date ? moment(target_date).format("Do MMM YYYY") : "-",
    },
    {
      title: "Store",
      dataIndex: "store_details",
      key: "store_details",
      width: 300,
      align: "start",
      className: "center-column",
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      key: "created_by",
      width: 80,
      align: "center",
      className: "center-column",
    },
    {
      title: "Action Plan",
      dataIndex: "action_plan_description",
      key: "action_plan_description",
      width: 500,
      align: "start",
      className: "center-column",
      render: (text) => (
        <div
          style={{
            maxHeight: "100px",
            overflowY: "auto",
            whiteSpace: "pre-line",
            scrollbarWidth: "thin",
            fontSize: "14px",
            lineHeight: "18px",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      className: "center-column",
      width: 130,
      render: (status) => (
        <div className="pendingTd d-flex justify-content-center align-items-center">
          <div
            className={`status ${status === "TAKEN" ? "taken" : "pending"
              } d-flex align-items-center justify-content-center`}
            style={{
              backgroundColor: status === "TAKEN" ? "#E9FFEF" : "#FFF2DD",
              borderRadius: "10px",
              width: "135px",
              height: "30px",
            }}
          >
            <i
              style={{
                fontSize: "2.2rem",
                margin: "0",
                color: status === "TAKEN" ? "#409261" : "#D98634",
              }}
              className="bi bi-dot"
            ></i>{" "}
            <p
              className="my-2"
              style={{
                fontWeight: "400",
                fontSize: "13px",
                lineHeight: "14px",
                color: status === "TAKEN" ? "#409261" : "#D98634",
              }}
            >
              {status === "TAKEN" ? "Action Taken" : "Action Pending"}
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Report",
      key: "report",
      className: "center-column",
      render: (text, row) => (
        <div className="reportAction">
          {row.status === "PENDING" ? (
            <div className="penComp d-flex gap-2 align-items-center justify-content-center">
              <button
                className="markBtn"
                onClick={() => handleMarkAsCompleted(row.id)}
              >
                {" "}
                Mark as Completed
              </button>
              <Link
                to={{ pathname: `/auditReport/${row.audit_store_id}` }}
                state={{ auditStoreId: row.audit_store_id }}
                className="reportBtnAT"
              >
                <button className="reportBtnAT">Report</button>
              </Link>
            </div>
          ) : (
            <div className="d-flex justify-content-center">
              <Link
                to={{ pathname: `/auditReport/${row.audit_store_id}` }}
                state={{ auditStoreId: row.audit_store_id }}
                className="reportBt"
              >
                <button className="reportBt">Report</button>
              </Link>
            </div>
          )}
        </div>
      ),
    },
  ];
  const menu = (
    <Menu>
      <Menu.Item key="ALL" onClick={() => setStatusFilter("ALL")}>
        All
      </Menu.Item>
      <Menu.Item key="PENDING" onClick={() => setStatusFilter("PENDING")}>
        Pending
      </Menu.Item>
      <Menu.Item key="TAKEN" onClick={() => setStatusFilter("TAKEN")}>
        Action Taken
      </Menu.Item>
    </Menu>
  );
  const downloadTableAsExcelObs = async (cycleId) => {
    const token = localStorage.getItem("authToken");
    const apiUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/audit_cycle/${cycleId}/action_reports_xlsx`;
    const hideLoading = message.loading("Downloading detailed excel, please wait...", 0);
    try {
      const response = await axios.get(apiUrl, {
        responseType: "blob",
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
      });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const selectedCycleName =
        detailsData.find((cycle) => cycle.id === cycleId)?.name ||
        "Improvement area based details";
      const formattedCycleName = selectedCycleName.replace(/\s+/g, "");

      saveAs(blob, `${formattedCycleName} Action Plan List.xlsx`);
      hideLoading();
      message.success("Exported Successfully");
    } catch (error) {
      hideLoading();
      message.error("Sorry something went wrong!! Please try again later");
      console.error("Error downloading Excel file:", error);
    }
  };

  return (
    <div style={{ minHeight: "850px" }}>
      <div className="AtHeroSection">
        <div className="head d-flex align-items-center justify-content-between flex-wrap mt-3">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <div className="d-flex align-items-center gap-2">
              <p className="AtQuesHeading">Questionnaire Type:</p>
              <select
                value={selectedOption}
                onChange={handleSelectChange}
                className="at-select"
              >
                {queTypesData?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="d-flex align-items-center gap-2">
              <p className="RbQuesHeading">Type of Audit:</p>
              <select
                value={selectedOption1}
                onChange={handleSelectChange1}
                className="auditCycleAT"
              >
                {detailsData?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="d-flex align-items-center gap-3 manage">
            <Dropdown overlay={menu} trigger={["click"]}>
              <div className="filterAT d-flex align-items-center gap-2">
                <p className="filterText my-1">Filter</p>
                <div className="filterIcon">
                  <i className="bi bi-filter"></i>
                </div>
              </div>
            </Dropdown>
            <div
              onClick={() => setStatusFilter("ALL")}
              className="clearFilter-at d-flex align-items-center"
            >
              <p className="my-1">Clear Filter</p>
              <Tooltip title="Clear Filter">
                <i className="bi bi-arrow-clockwise clearFilter-icon"></i>{" "}
              </Tooltip>
            </div>
            {!(tabData.length === 0 || newFilterData.length === 0) && (
              <div
                className="exportBtnAT d-flex align-items-center"
                onClick={() => {
                  if (cycleId) {
                    downloadTableAsExcelObs(cycleId);
                  } else {
                    console.error("Cycle ID is not available!");
                  }
                }}
              >
                <Tooltip title="Export List">
                  <VerticalAlignBottomOutlined className="exportIconAT" />
                </Tooltip>
                <p className="export-text my-2">Export List</p>
              </div>
            )}
          </div>
        </div>
        {openDropdown && (
          <div ref={dropdownRef}>
            <ul className="dropdown-menu shadow-lg d-grid gap-1 p-2 rounded-3 mx-0 w-220px">
              <li>
                <div
                  className="dropList d-flex justify-content-between align-items-center"
                  onClick={() => {
                    setStatusFilter("ALL");
                    setOpenDropdown(false);
                  }}
                >
                  <p className="my-2">All</p>
                </div>
              </li>
              <li>
                <div
                  className="dropList d-flex justify-content-between align-items-center"
                  onClick={() => {
                    setStatusFilter("PENDING");
                    setOpenDropdown(false);
                  }}
                >
                  <p className="my-2">Pending</p>
                </div>
              </li>
              <li>
                <div
                  className="dropList d-flex justify-content-between align-items-center"
                  onClick={() => {
                    setStatusFilter("TAKEN");
                    setOpenDropdown(false);
                  }}
                >
                  <p className="my-2">Action Taken</p>
                </div>
              </li>
            </ul>
          </div>
        )}
        <TableStyle
          columns={columns}
          dataSource={newFilterData}
          rowKey={(record, index) => `${record.id}-${index}`}
          loading={isLoading}
          pagination={false}
          scroll={{ x: "max-content" }}
          style={{ marginTop: "2rem" }}
        />
      </div>
    </div>
  );
};

const TableStyle = newStyled(Table)`
:where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-cell, :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-thead>tr>th{
padding : 4px 2px !important;
}
:where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-thead >tr>th{
    text-align : start !important;
}
    :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-thead > tr > th.center-column {
  text-align: center !important;
}

.ant-table-thead > tr {
  border-bottom: none !important;
}

.ant-table-thead > tr > th {
  border-bottom: none !important;
}

.ant-table-tbody > tr {
  border-top: none !important;
  border-bottom: none !important;
}

.ant-table-tbody > tr:nth-child(odd) {
    background-color: rgb(242,242,242) !important;
  }

  .ant-table-tbody > tr:nth-child(even) {
    background-color: #ffffff !important;
  
  }

  /* Hover effect - swap colors */
  .ant-table-tbody > tr:nth-child(odd):hover {
    background-color: rgb(242,242,242) !important;

  }

  .ant-table-tbody > tr:nth-child(even):hover {
    background-color: rgb(242,242,242) !important;
   
  }

`;

export default ActionTrack;
